import React from "react";
import summaryStyle from "./summaryStyle";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

type DebtCollectionAgencyDataProps = {
  formData: Record<string, any>;
  title: string;
};

const DebtCollectionAgencyData = ({ formData, title }: DebtCollectionAgencyDataProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>{title}</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"name"} sx={summaryStyle.scrollToAnchor} />
        Name Inkassobüro
      </Grid>
      <Grid size={12}>
        {formData.debtCollectionAgency.organization.name}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"debtCollectionAgencyReference"} sx={summaryStyle.scrollToAnchor} />
        Aktenzeichen Inkassobüro
      </Grid>
      <Grid size={12}>
        {formData.debtCollectionAgencyReference}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"streetAddress"} sx={summaryStyle.scrollToAnchor} />
        Straße und Hausnummer
      </Grid>
      <Grid size={12}>
        {formData.debtCollectionAgency.organization.address.streetAddress}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"postalCode"} sx={summaryStyle.scrollToAnchor} />
        Postleitzahl
      </Grid>
      <Grid size={12}>
        {formData.debtCollectionAgency.organization.address.postalCode}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"addressLocality"} sx={summaryStyle.scrollToAnchor} />
        Ort
      </Grid>
      <Grid size={12}>
        {formData.debtCollectionAgency.organization.address.addressLocality}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"email"} sx={summaryStyle.scrollToAnchor} />
        E-Mail-Adresse
      </Grid>
      <Grid size={12}>
        {formData.debtCollectionAgency.organization.mainEmail.email}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"telephone"} sx={summaryStyle.scrollToAnchor} />
        Telefonnummer
      </Grid>
      <Grid size={12}>
        {formData.debtCollectionAgency.organization.telephone}
      </Grid>
    </>
  );
};

export default DebtCollectionAgencyData;
